import React from 'react';
import { colorPalette } from '@next-common/mui';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
export const UnavailableContent = ({ isEshop }) => {
    return (React.createElement(Box, null,
        React.createElement(Stack, { sx: {
                padding: '16px',
                borderRadius: '8px',
                backgroundColor: colorPalette.gray100,
            } },
            React.createElement(Typography, { color: colorPalette.gray900, fontWeight: '600' }, "Personne responsable dans l\u2019Union europ\u00E9enne (UE) :"),
            React.createElement(Typography, { color: colorPalette.gray900, sx: {
                    marginTop: '8px',
                } }, "La Personne Responsable dans l\u2019UE ou \u201COp\u00E9rateur Economique\u201D, est la personne en charge de nombreux aspects de la conformit\u00E9 et de la s\u00E9curit\u00E9 d\u2019un produit sur le march\u00E9 europ\u00E9en.")),
        React.createElement(Typography, { sx: {
                marginTop: '16px',
            }, color: colorPalette.gray700 },
            `${isEshop ? "Ce vendeur n'a pas " : "Aucun vendeur n'a "}`,
            "encore transmis les coordonn\u00E9es de son op\u00E9rateur \u00E9conomique pour ce produit sp\u00E9cifique. Cette information peut \u00EAtre mise \u00E0 jour \u00E0 tout moment.")));
};
